import React, { useState } from 'react';
import './FaqSection.css';

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0); 

  const faqData = [
   {
    "title": "Can Canadian citizens access your services?",
    "content": "Yes. Canadian citizens—whether self-employed or employed through a corporation—can access our services directly. Many of our members choose to pay through a corporate structure, which may provide tax efficiency depending on your accountant’s recommendations."
  },
  {
    "title": "Can foreign nationals access your program?",
    "content": "Absolutely. We welcome foreign nationals, expats, and internationally based professionals. While OHIP coverage may not apply to all services, we can tailor programs for individuals who wish to receive comprehensive preventive care while living or working in Canada."
  },
  {
    "title": "Do you accept families into the program?",
    "content": "Yes, we do. While our program is designed for individual optimization, many of our members enroll their spouses or family members to ensure consistency in care and convenience. We offer flexible arrangements for dual or family memberships."
  },
  {
    "title": "Do you work with elderly patients?",
    "content": "Yes. Many of our members are in their 60s, 70s, or beyond. Preventive care becomes increasingly valuable with age, and our team is experienced in addressing age-specific concerns with dignity, thoroughness, and a personalized approach."
  },
  {
    "title": "Are there any tax benefits to joining?",
    "content": "Potentially, yes. If you're an incorporated business owner or executive, your accountant may be able to classify our services as a business expense. While we don’t provide financial advice, many members explore this option with their tax advisors."
  }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="ttc-faq-main-wrapper py-5">
      <div className="container py-lg-4">
        <div className="row align-items-center gy-5">
          {/* Left Side Image */}
          <div className="col-12 col-lg-5">
            <div className="ttc-faq-image-box">
              <img 
                src="/images/creatives/landing-faqs-side-image.jpg" 
                alt="Medical team collaborating" 
                className="img-fluid rounded-4 shadow-sm w-100 ttc-faq-img"
              />
            </div>
          </div>

          {/* Right Side Accordion */}
          <div className="col-12 col-lg-7 ps-lg-5">
            <h2 className="ttc-faq-main-heading mb-4">Frequently Asked Questions</h2>

            <div className="ttc-faq-accordion">
              {faqData.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div 
                    key={index} 
                    className={`ttc-faq-item ${isOpen ? 'is-open' : ''}`}
                  >
                    <button
                      type="button"
                      className="ttc-faq-header w-100 d-flex align-items-center justify-content-between text-start"
                      onClick={() => toggleFaq(index)}
                      aria-expanded={isOpen}
                    >
                      <span className="ttc-faq-title">{faq.title}</span>
                      <span className="ttc-faq-icon">{isOpen ? '×' : '+'}</span>
                    </button>

                    <div className="ttc-faq-content-wrapper">
                      <p className="ttc-faq-content mb-0">{faq.content}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FaqSection;